import ReactGA from 'react-ga4';

export const sendToGa = ({ category, action }) => {
  ReactGA.event({ category, action });
};

export const sendProjectAction = (action) => {
  sendToGa({ category: 'Project', action });
};

export const sendArchiveAction = (action) => {
  ReactGA.event({
    category: 'Archive',
    action,
  });
};

export const sendNotificationClicked = () => {
  sendToGa({ category: 'Notification', action: 'Clicked' });
};

export const sendCurrencyAction = (action) => {
  ReactGA.event({ category: 'Currency', action });
};

export const sendUserAction = (action) => {
  ReactGA.event({ category: 'User', action });
};
export const sendUserActionWithId = (action, id) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.gtag('event', 'user_action', {
    event_category: 'User',
    event_label: 'Hashed Email',
    value: 1,
    hashed_email: id,
  });
};
